module.exports = __webpack_public_path__ + "img/detail_08.c0662952.png";